import { Chip } from '@mui/material';
import { cn } from 'cn';

import { type UUID } from '~/types/common';

import ToastService from '~/services/toast.service';

import { i18n } from '~/utils';

import { CopyToClipboard } from '@vestigas/ui/molecules';

type P = {
  readonly id: UUID | undefined;
  readonly isStyledUuid?: boolean;
  readonly size?: 'small' | 'medium';
  readonly successMessage?: string;
} & ComponentStyling;

const defaultSuccessMessage = i18n.t(($) => $.itemId.copySuccess);

export const ItemUUID = ({
  className,
  id,
  style,
  isStyledUuid = true,
  size = 'small',
  successMessage = defaultSuccessMessage,
}: P) => {
  if (!id) {
    return null;
  }

  const label = isStyledUuid ? (
    <span className="flex items-center justify-center">
      <code className="text-tiga-text-default">{id.slice(0, 3)}</code>
      <span className="relative inline-flex items-center overflow-hidden">
        <span className="w-[2ch] text-center text-tiga-text-lighter transition-all duration-200 ease-out will-change-auto group-hover:w-0 group-hover:opacity-0 group-hover:duration-50">
          …
        </span>
        <code className="w-0 whitespace-nowrap opacity-0 transition-all duration-200 ease-out group-hover:w-[30ch] group-hover:text-tiga-text-default group-hover:opacity-100">
          {id.slice(3, 33)}
        </code>
      </span>
      <code className="text-tiga-text-default">{id.slice(-3)}</code>
    </span>
  ) : (
    id
  );

  return (
    <CopyToClipboard
      className="inline"
      value={id}
      onSuccess={() => {
        ToastService.info(successMessage);
      }}
    >
      <Chip
        className={cn(
          `group -ml-1 min-w-[8ch] border border-tiga-border-lighter bg-white font-mono text-tiga-text-default transition-all duration-300 ease-out hover:bg-white`,
          className,
        )}
        label={label}
        size={size}
        style={style}
        variant="outlined"
      />
    </CopyToClipboard>
  );
};
